
window.onload = function() {
  let carousels = document.getElementsByClassName("swiper")

  if (carousels.length > 0) {
    for (let i = 0; i < carousels.length; i++) {
      const carousel_id = carousels[i].getAttribute("id")
      const swiper = new Swiper(`#${carousel_id}`, {
        // Optional parameters
        direction: 'horizontal',
        loop: false,
        centeredSlides: true,
        spaceBetween: 20,
        slidesPerView: 2,
        slideToClickedSlide: true,
        breakpoints: {
          764: {
            centeredSlides: false,
            slidesPerView: 3,
            spaceBetween: 20,
          },
          1200: {
            centeredSlides: false,
            slidesPerView: 5,
            spaceBetween: 30
          },
        },
        scrollbar: {
          el: '.swiper-scrollbar',
          draggable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }
      });
    }
  }
  
}